import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e2d8d14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PermissionsListItem" }
const _hoisted_2 = { class: "text-base font-semibold" }
const _hoisted_3 = { class: "flex items-center justify-end mt-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, "(ID: " + _toDisplayString(_ctx.item.id) + ") " + _toDisplayString(_ctx.item.name), 1),
    _createElementVNode("p", null, _toDisplayString(_ctx.item.description), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_the_button, {
        class: "primary text small mr-2",
        onClick: _ctx.emitUpdate,
        loading: _ctx.loading
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(" Редактировать ")
        ]),
        _: 1
      }, 8, ["onClick", "loading"]),
      _createVNode(_component_the_button, {
        class: "red text small",
        onClick: _ctx.emitDelete,
        loading: _ctx.loading
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          _createTextVNode(" Удалить ")
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ])
  ]))
}